import * as React from 'react';

export const DropdownContext
  = React.createContext<Partial<DropdownProviderProps>>({});


export interface DropdownProviderProps {
  isToggle: boolean;
  children: React.ReactNode;
  open(): void;
  close(): void;
}

/**
 * The dropdown context provider.
 * @param {DropdownProviderProps} props
 * @return {JSX.Element}
 * @constructor
 */
export function DropdownProvider(props: DropdownProviderProps) {
  const {Provider} = DropdownContext;

  return (
    <Provider value={props}>
      {props.children}
    </Provider>
  );
}
